import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function Journalctl() {
    return (
        <div className={globalStyles.article}>
            <h1>journalctl</h1>

            <p><b>journalctl</b> reads the systemd journal — the centralized, binary log that
                <code> systemd-journald</code> collects from services, the kernel and boot messages. It replaces
                grepping through separate files under <code>/var/log/</code> for anything managed by systemd.</p>

            <h3>Filtering</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> journalctl -u nginx <i># only this unit's logs</i><br/>
    <b>user@host:~$</b> journalctl -u nginx -f <i># follow, like tail -f</i><br/>
    <b>user@host:~$</b> journalctl -b <i># only logs since the last boot</i><br/>
    <b>user@host:~$</b> journalctl -b -1 <i># logs from the previous boot</i><br/>
    <b>user@host:~$</b> journalctl --since "2026-09-07 09:00" --until "2026-09-07 10:00"<br/>
    <b>user@host:~$</b> journalctl --since "1 hour ago"<br/>
    <b>user@host:~$</b> journalctl -p err <i># priority: err and above</i><br/>
    <b>user@host:~$</b> journalctl -k <i># kernel messages only, like dmesg</i><br/>
            </pre>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Priority levels (-p)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>0</b></td>
                        <td>emerg</td>
                    </tr>
                    <tr>
                        <td><b>1</b></td>
                        <td>alert</td>
                    </tr>
                    <tr>
                        <td><b>2</b></td>
                        <td>crit</td>
                    </tr>
                    <tr>
                        <td><b>3</b></td>
                        <td>err</td>
                    </tr>
                    <tr>
                        <td><b>4</b></td>
                        <td>warning</td>
                    </tr>
                    <tr>
                        <td><b>5-7</b></td>
                        <td>notice / info / debug</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Output format</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> journalctl -u nginx -o json-pretty <i># structured, one field per line</i><br/>
    <b>user@host:~$</b> journalctl -u nginx --no-pager <i># don't page, print and exit</i><br/>
            </pre>

            <h3>Managing disk usage</h3>
            <p>The journal can grow large if it isn't capped; check and trim it with:</p>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> journalctl --disk-usage<br/>
    <b>root@host:~#</b> journalctl --vacuum-size=500M <i># shrink to at most 500MB</i><br/>
    <b>root@host:~#</b> journalctl --vacuum-time=2weeks <i># drop entries older than 2 weeks</i><br/>
            </pre>

            <p>By default the journal may only be kept in memory/tmpfs (volatile) on some distros. To persist it
                across reboots: <code>mkdir -p /var/log/journal &amp;&amp; systemctl restart systemd-journald</code>.</p>
        </div>
    )
}
